<template>
  <div>
    <create-codes
      :old-code="codeDetail"
      :active="modalActive"
      :editable="editable"
      :action="actionSelected"
      @input="bindCodeValue"
      @close-modal="closeModal" />
    <validation-observer
      ref="actionStepObs"
      tag="form"
      @submit.prevent="stepSubmit">
      <v-col
        cols="12"
        class="mt-n5">
        <validation-provider
          v-slot="{ errors }"
          name="Action"
          rules="required">
          <v-radio-group
            v-model="actionSelected"
            :error-messages="errors[0]"
            :readonly="!editable">
            <v-radio
              v-for="(action, index) in actions"
              :key="index"
              :label="action.text"
              :value="action.value"
              @click.native="selectAction(action.value)" />
          </v-radio-group>
        </validation-provider>
      </v-col>
      <v-col
        cols="12"
        class="d-flex">
        <v-spacer />
        <v-btn
          v-if="editable"
          color="primary"
          type="submit">
          ต่อไป
        </v-btn>
      </v-col>
    </validation-observer>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CreateCodes from '../codes/CreateCodes.vue'

export default {
  components: {
    CreateCodes
  },
  props: {
    oldAction: {
      type: Object,
      default: () => {}
    },
    editable: {
      type: Boolean,
      default: false
    },
    templateIndex: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      modalActive: false,
      actionSelected: 'generateNewCode',
      codeDetail: {},
      actions: [
        { text: 'สร้างโค้ดส่วนลดใหม่', value: 'generateNewCode' },
        { text: 'ใช้โค้ดส่วนลดที่มีอยู่แล้ว', value: 'useOldCodes' },
        { text: 'ไม่ใช้โค้ด', value: 'noCode' }
      ]
    }
  },
  watch: {
    oldAction: {
      async handler () {
        this.initAction()
      },
      deep: true
    }
  },
  async mounted () {
    this.initAction()
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar',
      setModal: 'Style/setModal'
    }),
    initAction () {
      if (this.oldAction) {
        this.actionSelected = this.oldAction.action || ''
        this.codeDetail = this.oldAction.more || {}
      }

      if (this.templateIndex > 0) {
        this.actions = [
          { text: 'สร้างโค้ดส่วนลดใหม่', value: 'generateNewCode' },
          { text: 'ใช้โค้ดส่วนลดที่มีอยู่แล้ว', value: 'useOldCodes' },
          { text: 'คนที่ยังไม่ใช่โค้ด', value: 'didntUseCode' },
          { text: 'ไม่ใช้โค้ด', value: 'noCode' }
        ]
      }
    },
    closeModal (modal) {
      this.modalActive = modal
    },
    selectAction (val) {
      if (val === 'generateNewCode') {
        this.modalActive = true
      }
    },
    returnValue () {
      this.$emit('input', {
        action: {
          action: this.actionSelected,
          more: this.codeDetail
        }
      }, 1)
    },
    bindCodeValue (val) {
      this.codeDetail = val
    },
    async stepSubmit () {
      try {
        const validated = await this.$refs.actionStepObs.validate()
        if (validated) {
          this.returnValue()
        } else {
          this.setSnackBar({
            value: true,
            message: 'กรุณากรอกฟอร์มให้ถูกต้องและครบถ้วน',
            type: 'warning'
          })
        }
      } catch (e) {
        this.setSnackBar({
          value: true,
          message: `มีบางอย่างไม่ถูกต้อง (${e.message})`,
          type: 'error'
        })
      }
    },
    stepBack () {
      this.$emit('step-back')
    }
  }
}
</script>
